<template>
    <div class="address-component">
        <b-field class="is-relative">
            <input ref="placeSearchAutocomplete"
            :placeholder="placeholder"
            class="input place-autocomplete"
            type="text"
            :required="required"
            :value="value" />

            <a @click="clearValue" class="clear-value-link">Clear</a>
        </b-field>
    </div>
</template>

<script>


export default {
    name: 'Address',
    components: {
    },
    props: {
        component: Object,
        value: String,
        required: Boolean,
    },
    data: function () {
        return {
        }
    },
    mounted () {

        const inputField = this.$refs.placeSearchAutocomplete
        const config = {
            types: ['geocode']
        }

        this.autocomplete = new window.google.maps.places.Autocomplete(inputField, config)

        this.autocomplete.setFields(['formatted_address'])
        this.autocomplete.addListener('place_changed', this.fillInAddress)
    },
    methods: {
        fillInAddress() {
            const place = this.autocomplete.getPlace();
            this.value = place.formatted_address
            this.$emit('input', this.value);
        },
        clearValue() {
          this.value = ''
          this.$emit('input', this.value);
        }
    }, 
    computed: {
        placeholder () {
            return this.component.placeholder ?? null
        },
    }
}

</script>

<style scoped>
.clear-value-link {
  position: absolute;
  right: 0;
  color: #ccc;
  font-size: 12px;
  line-height: 40px;
  padding: 0 15px;
}
</style>

